'use client'
import React, { useState } from 'react'

import { Accordion } from '@/_components/ui/accordion'
import { IFAQGroup } from '@/_types/faq-group'

import AFaqItem from './a-faq-item'

const AFaqTextTopList: React.FC<{ faqs: IFAQGroup['faqs'] }> = ({ faqs }) => {
	const [showAll, setShowAll] = useState(false)
	const initialItems = 6
	const visibleItems = showAll ? faqs : faqs.slice(0, initialItems)
	const hasMoreItems = faqs.length > initialItems

	return (
		<div className='box_accord accord'>
			<div className='box_accord_items cf'>
				{/* Left Column */}
				<div className='col'>
					<Accordion
						type='single'
						collapsible
						className='w-full border-none'
						suppressHydrationWarning={true}
					>
						{visibleItems
							.slice(0, Math.ceil(visibleItems.length / 2))
							.map((item, index) => (
								<AFaqItem
									key={index}
									question={item.question}
									answer={item.answer}
									index={index * 2}
								/>
							))}
					</Accordion>
				</div>

				{/* Right Column */}
				<div className='col'>
					<Accordion
						type='single'
						collapsible
						className='w-full border-none'
						suppressHydrationWarning={true}
					>
						{visibleItems
							.slice(Math.ceil(visibleItems.length / 2))
							.map((item, index) => (
								<AFaqItem
									key={index}
									question={item.question}
									answer={item.answer}
									index={index * 2 + 1}
								/>
							))}
					</Accordion>
				</div>
			</div>

			{/* Controls */}
			<div className='box_faq_controls grid lg:flex flex-nowrap-lg justify-between justify-center-lgm text_center_lgm'>
				<div className='col_default col1_lgm page_content text_s14 mgt-40 text-start max-w-[400px]'>
					V prípade ďalších otázok neváhajte kontaktovať naše klientske centrum e-mailom
					na <a href='mailto:recepcia@medante.sk'>recepcia@medante.sk</a>
				</div>

				{hasMoreItems ? (
					<div className='col_default order-last-lg col1_lgm mgt-40'>
						<a
							href='#'
							title=''
							className='btn_more'
							onClick={e => {
								e.preventDefault()
								setShowAll(!showAll)
							}}
						>
							<span>{showAll ? 'Skryť otázky' : 'Zobraziť ďalšie otázky'}</span>
							<span>
								<svg className='sico'>
									{showAll ? (
										<use href='/assets/layout/icons.svg#s_ar1_d' />
									) : (
										<use href='/assets/layout/icons.svg#s_ar1_u' />
									)}
								</svg>
							</span>
						</a>
					</div>
				) : (
					<div className='col_default order-last-lg col1_lgm'></div>
				)}
			</div>
		</div>
	)
}

export default AFaqTextTopList
